import { Suspense, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
// @polaris
import { Page, Button, Modal, Box } from "@shopify/polaris";
// components
import { Loader } from "..";
import NewSellingPlanForm from "../../pages/Settings/components/NewSellingPlanFrom";
import NewSettingForm from "../../pages/Settings/components/NewSettingForm";
import TitleBar from "./TitleBar";
// constants
import { APP_ROUTES } from "../../common/constants";
// hooks
import useLocales from "../../hooks/useLocales";

const SettingsLayout = () => {
  const [isDialogActive, setDialogActive] = useState(false);

  const { translate } = useLocales();
  const { pathname } = useLocation();

  const toggleDialogActive = () => setDialogActive(!isDialogActive);

  const PAGE = {
    [APP_ROUTES.SETTINGS.ROOT]: {
      title: translate("page.settings.title"),
    },
    [APP_ROUTES.SETTINGS.TEMPLATES]: {
      title: "Templates",
      actionTitle: translate("page.settings.new-settings-btn"),
      dialogTitle: translate("page.setting.create-setting-template"),
      dialogForm: <NewSettingForm handleOnClose={toggleDialogActive} />,
    },
    [APP_ROUTES.SETTINGS.SELLING_PLANS]: {
      title: "Selling Plans",
      actionTitle: translate("page.selling-plans.new-plan-btn"),
      dialogTitle: translate("page.selling-plans.create-plan"),
      dialogForm: <NewSellingPlanForm handleOnClose={toggleDialogActive} />,
    },
    [APP_ROUTES.SETTINGS.ADVANCED.SELECTORS]: {
      title: "Developer Settings",
      actionTitle: null,
      dialogTitle: null,
      dialogForm: null,
    },
  };

  const { actionTitle, dialogTitle, dialogForm /*, heading */ } = PAGE[pathname] || {};

  const breadcrumb =
    pathname === APP_ROUTES.SETTINGS.ROOT
      ? {}
      : {
          name: translate("page.settings.title"),
          href: APP_ROUTES.SETTINGS.ROOT,
        };

  return (
    <Page>
      <Box paddingInline={{ xs: "400", sm: "0" }}>
        <TitleBar
          heading={PAGE[pathname].title}
          breadcrumb={breadcrumb}
          action={
            actionTitle ? (
              <Button variant="primary" onClick={toggleDialogActive}>
                {actionTitle}
              </Button>
            ) : null
          }
        />

        <Suspense fallback={<Loader />}>
          <Outlet />
        </Suspense>

        {dialogTitle && dialogForm && (
          <Modal open={isDialogActive} onClose={toggleDialogActive} title={dialogTitle}>
            {dialogForm}
          </Modal>
        )}
      </Box>
    </Page>
  );
};

export default SettingsLayout;
